import React, { useEffect, useState } from "react";
import { db } from "./firebase";
import { ref, onValue } from "firebase/database";
import { useNavigate } from "react-router-dom";

// === Styles (نفس ProductsPage) ===
const th = { padding: 12, background: "#f3f4f6", fontWeight: 600 };
const td = { padding: 12, borderBottom: "1px solid #e5e7eb" };
const btn = {
  padding: "6px 12px",
  borderRadius: 6,
  border: "none",
  cursor: "pointer",
  background: "#007bff",
  color: "#fff",
};

export default function LowStockProducts({ uid }) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (!uid) return;

    const productsRef = ref(db, `distributors/${uid}/products`);

    const unsub = onValue(productsRef, snap => {
      const val = snap.val() || {};

      const lowStockProducts = Object.keys(val)
        .map(id => ({ id, ...val[id] }))
        .filter(p => p.quantity < 10)
        .sort((a, b) => a.quantity - b.quantity); // الأقل أولاً

      setProducts(lowStockProducts);
      setLoading(false);
    });

    return () => unsub();
  }, [uid]);

  if (loading) return <p style={{ padding: 20 }}>Chargement...</p>;

  return (
    <div style={{ padding: 20 }}>
      <h2>Produits à Stock Faible</h2>

      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={th}>Image</th>
            <th style={th}>Nom</th>
            <th style={th}>Marque</th>
            <th style={th}>Catégorie</th>
            <th style={th}>Prix</th>
            <th style={th}>Quantité</th>
            <th style={th}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {products.length > 0 ? (
            products.map(p => (
              <tr key={p.id}>
                <td style={td}>
                  <img
                    src={p.imageUrl || "https://via.placeholder.com/40"}
                    alt={p.name}
                    width={40}
                  />
                </td>
                <td style={td}>{p.name}</td>
                <td style={td}>{p.brandName || "-"}</td>
                <td style={td}>{p.categoryName || "-"}</td>
                <td style={td}>{p.price} DA</td>
                <td style={{ ...td, color: "#dc3545", fontWeight: "bold" }}>
                  {p.quantity}
                </td>
                <td style={td}>
                  <button
                    style={btn}
                    onClick={() => navigate(`/products/edit/${p.id}`)}
                  >
                    Modifier
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={7} style={{ padding: 30, textAlign: "center" }}>
                🎉 Aucun produit à stock faible
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
